import { AlertCircle, CheckCircle2, Info, X } from 'lucide-react';
import { type Toast, useToastStore } from '@/stores/toast-store';

const ICONS: Record<Toast['type'], React.ReactNode> = {
  success: <CheckCircle2 className="w-4 h-4 text-green-500" />,
  error: <AlertCircle className="w-4 h-4 text-red-500" />,
  info: <Info className="w-4 h-4 text-blue-500" />,
};

const BG: Record<Toast['type'], string> = {
  success: 'bg-green-50 border-green-200',
  error: 'bg-red-50 border-red-200',
  info: 'bg-blue-50 border-blue-200',
};

export function ToastContainer() {
  const toasts = useToastStore(s => s.toasts);
  const dismiss = useToastStore(s => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 max-w-sm">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`flex items-start gap-2.5 px-4 py-3 rounded-lg border shadow-sm
                      animate-[slideIn_0.2s_ease-out] ${BG[t.type]}`}
        >
          <span className="mt-0.5 shrink-0">{ICONS[t.type]}</span>
          <p className="text-sm text-gray-800 flex-1">{t.message}</p>
          <button
            onClick={() => dismiss(t.id)}
            className="text-gray-400 hover:text-gray-600 shrink-0 mt-0.5"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
